{
  "state": {
    "DRAFT": "Draft",
    "IN_CUSTODY": "In our custody",
    "DELIVERED": "Delivered",
    "RETURNED": "Returned",
    "CANCELLED": "Cancelled"
  },
  "party": {
    "depositor": "Depositor",
    "intendedRecipient": "Intended recipient",
    "actualRecipient": "Actual recipient",
    "noIntended": "Not specified",
    "customerNotPresent": "Customer not present"
  },
  "field": {
    "number": "Deposit number",
    "reference": "Reference Number",
    "amount": "Amount",
    "currency": "Currency",
    "branch": "Branch",
    "location": "Storage location",
    "notes": "Notes",
    "status": "Status",
    "fullName": "Full Name",
    "phone": "Phone",
    "documentType": "Document Type",
    "documentNumber": "Document Number",
    "issuingCountry": "Issuing Country",
    "signature": "Signature",
    "recipientAvailable": "Recipient details available",
    "depositEmployee": "Deposit employee",
    "deliveryEmployee": "Delivery employee",
    "returnEmployee": "Return employee"
  },
  "documentType": {
    "NATIONAL_ID": "National ID",
    "PASSPORT": "Passport"
  },
  "message": {
    "PENDING": "Awaiting sending",
    "SENT": "Sent",
    "FAILED": "Sending failed",
    "resend": "Resend"
  },
  "flag": {
    "awaitingSync": "Awaiting synchronisation",
    "documentOwnedByOther": "This document belongs to another customer",
    "referralPending": "Awaiting supervisor review",
    "signedEarlierVersion": "Signed on an earlier version"
  },
  "action": {
    "newDeposit": "New deposit",
    "newDepositAgain": "New deposit",
    "deliver": "Deliver a deposit",
    "returnToDepositor": "Return to the depositor",
    "return": "Return",
    "sendToTablet": "Send to tablet",
    "resendToTablet": "Resend to tablet",
    "confirmDeposit": "Confirm deposit",
    "confirmDelivery": "Confirm delivery",
    "scanCode": "Scan code",
    "takeDocumentPhoto": "Take document photo",
    "printReceipt": "Print receipt",
    "reprint": "Reprint",
    "referToSupervisor": "Refer to supervisor",
    "reviewReferral": "Review referral",
    "cancelDeposit": "Cancel deposit",
    "approve": "Approve",
    "reject": "Reject"
  },
  "receipt": {
    "title": "Deposit receipt",
    "heading": "Deposit receipt",
    "dateTime": "Date and time",
    "declaration": "Depositor declaration",
    "qrAlt": "Deposit QR code"
  },
  "edit": {
    "reason": "Edit reason",
    "history": "Edit history"
  },
  "referral": {
    "decision": "Supervisor decision"
  },
  "tablet": {
    "label": "Tablet",
    "choose": "Choose a tablet",
    "online": "Online",
    "offline": "Offline",
    "none": "No active tablets in this branch",
    "busy": "The tablet is busy"
  },
  "compare": {
    "differs": "Different"
  },
  "file": {
    "loading": "Loading",
    "unavailable": "The file cannot be shown"
  },
  "match": {
    "title": "Registered customer",
    "notFound": "No customer is registered with this phone",
    "unavailable": "The Customers system cannot be reached now",
    "level": "Level"
  }
}
